import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "cookie_consent_v1";
const ConsentContext = createContext({
  consent: null, // null = not decided yet
  set: () => {},
  reset: () => {},
});

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) {
        const data = JSON.parse(raw);
        if (data && typeof data === "object") setConsent(data);
      }
    } catch {
      /* ignore */
    }
  }, []);

  const set = useCallback((next) => {
    const value = {
      necessary: true, // always
      analytics: !!next?.analytics,
      marketing: !!next?.marketing,
      decided_at: Date.now(),
    };
    setConsent(value);
    try {
      localStorage.setItem(KEY, JSON.stringify(value));
    } catch {
      /* ignore */
    }
  }, []);

  const reset = useCallback(() => {
    setConsent(null);
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  }, []);

  return (
    <ConsentContext.Provider value={{ consent, set, reset }}>{children}</ConsentContext.Provider>
  );
}

export const useConsent = () => useContext(ConsentContext);
